import { CLOUD } from 'styles/Colors';
import { resendLinkToPay } from 'auth/LinkToPayApiCalls';
import BrokenExpiredLink from 'images/BrokenExpiredLink.svg';
import CtaButton from '@opploans/cta-button-component/CtaButton';
import MainLayout from 'components/component_lib/MainLayout';
import React, { useState } from 'react';

const containerStyle = {
  textAlign: 'center',
  padding: '0.75rem',

  h1: {
    fontSize: '1.5rem',
    fontWeight: 700,
    margin: '1rem 0'
  },

  h2: {
    fontSize: '1.25rem'
  }
};

const linkExpiredText = {
  marginTop: 0,
  textAlign: 'center'
};

const brokenExpiredLinkStyle = {
  marginTop: '2rem',
  backgroundColor: CLOUD,
  borderRadius: '50% 50%'
};

const buttonStyle = {
  fontSize: '1rem',
  height: '3rem',
  marginTop: '2rem',
  width: '100%'
};

function ExpiredLinkToPay() {
  const [loading, setLoading] = useState(false);

  async function handleResend(sendMethod) {
    setLoading(true);

    const shortenedUrl = window.location.pathname.split('/').pop();
    const response = await resendLinkToPay(shortenedUrl, sendMethod);

    if (response?.status === 201) {
      window.toastr.success(
        null,
        'A new link has been sent. Please check your device.'
      );
    } else {
      const title = response?.data?.errors?.at(0)?.title;
      const detail = title ? `\nCause: ${title}` : '';
      window.toastr.error(
        null,
        `An error occurred. Please try again later.${detail}`
      );
    }

    setLoading(false);
  }

  return (
    <MainLayout withFooter={false} additionalStyle={containerStyle}>
      <div>
        <h1>Uh Oh!</h1>
        <p css={linkExpiredText}>This link is expired.</p>
        <p css={linkExpiredText}>You can request a new link below.</p>
        <BrokenExpiredLink css={brokenExpiredLinkStyle} />
        <CtaButton
          additionalStyle={buttonStyle}
          loading={loading}
          onClick={() => handleResend('email')}
        >
          Send a New Link Via Email
        </CtaButton>
      </div>
    </MainLayout>
  );
}

export default ExpiredLinkToPay;
